import React from 'react'
import {Link} from "react-router-dom";

export default function Footer2() {
    return (
        <footer className="footer">
            <div className="shell">
                <div className="footer__inner">
                    <div className="footer__content">
                        <div className="footer__nav">
                            <ul>
                                <li>
                                    <a href="https://www.theroom.com/terms-conditions/" target="_blank">Terms & Conditions</a>
                                </li>
                                <li>
                                    <a href="https://www.theroom.com/privacy-policy/" target="_blank">Privacy Policy</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="copyright">
                        <p>&copy; Copyright The Room 2020</p>
                    </div>
                </div>
            </div>
        </footer>
    )
}